import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React, { forwardRef, useState, useEffect } from 'react';
import { useComboboxContext } from './useComboboxContext.js';
import { jsx } from '@emotion/react';
import { ComboboxPopup } from '../ComboboxPopup/ComboboxPopup.js';
import { StyledMenuItems } from '../Menu/MenuItems.js';
import '@floating-ui/react-dom';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Box/Box.js';
import '@indeed/ifl-css';
import '../Portal/Portal.js';
import 'react-dom';
import '../../reach-menu-button.esm-22bcdd5f.js';
import '../../reach-popover.esm-c19739dd.js';
import '../Menu/MenuItem.js';
import 'focus-visible';
import '../../utils/styled.js';

/**
 * ComboboxPopover
 *
 * Contains the popover that renders `ComboboxMenuList`. For accessibility
 * purposes, be sure to _always_ render `ComboboxMenuList` even if no options
 * match the current filter or if the popover is closed. An additional
 * `ReactNode` can be passed in when no options match the current filter or if
 * loading.
 *
 * @deprecated The `Combobox` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const ComboboxPopover = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  var _inputWrapperRef$curr;
  const {
    children,
    ...popoverProps
  } = props;
  const {
    items,
    isOpen,
    inputWrapperRef
  } = useComboboxContext();
  const [menuWidth, setMenuWidth] = useState(inputWrapperRef == null || (_inputWrapperRef$curr = inputWrapperRef.current) == null ? void 0 : _inputWrapperRef$curr.clientWidth);

  // Update the menu's width to be at least as wide as the input.
  useEffect(() => {
    // eslint-disable-next-line compat/compat
    const observer = new ResizeObserver(entries => {
      setMenuWidth(entries[0].contentRect.width);
    });
    if (inputWrapperRef != null && inputWrapperRef.current) {
      observer.observe(inputWrapperRef == null ? void 0 : inputWrapperRef.current);
    }
    return () => {
      observer.disconnect();
    };
  });

  /**
   * Hide menu if only `ComboboxMenuList` is passed as a child and there are
   * no items to render (`items.length`) within `ComboboxMenuList`.
   */
  const menuIsEmpty = React.Children.count(children) === 1 && items.length === 0;
  return jsx(ComboboxPopup, _extends({
    ref: forwardedRef,
    targetRef: inputWrapperRef,
    hidden: !isOpen
  }, popoverProps), jsx(StyledMenuItems, {
    sx: {
      alignItems: "center",
      minInlineSize: menuWidth,
      visibility: menuIsEmpty ? "hidden" : undefined
    }
  }, children));
});
ComboboxPopover.displayName = "ComboboxPopover";

export { ComboboxPopover };
